import {React, styled} from 'common'
import {useNavigate} from 'services/hooks'
import {useI18n} from 'store/Store'
import {Colors} from 'appearance'
import {
    FormAdditionalButton,
    FormAdditionalText,
    FormRow,
} from 'components/Control/Form'

const AlreadyRegisteredRow = () => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const translate = (label) => i18n.t('welcome.' + label)

    return (
        <AlreadyRegistered>
            <FormAdditionalText>
                {translate('alreadyRegistered')}
            </FormAdditionalText>
            <LoginButton
                sx={{color: Colors.TORQUISE}}
                onClick={() => navigate('/Login')}>
                {translate('login')}
            </LoginButton>
        </AlreadyRegistered>
    )
}

export default AlreadyRegisteredRow

const AlreadyRegistered = styled(FormRow)`
    padding: 10px 10px 0px 10px;
`
const LoginButton = styled(FormAdditionalButton)``
